// extracted by mini-css-extract-plugin
module.exports = {"masonryGrid":"TestimonialsSection_masonryGrid__mdpst","masonryItem":"TestimonialsSection_masonryItem__Pew1h"};